import { useContext, useState } from 'react'
import { SET_SELECTED_WIRE_DATA, WireContext } from '../context/context'
import InputText from '../../../common/InputText'
import TextArea from '../../../common/TextArea'
import CheckBox from '../../../common/CheckBox'
import SelectInput from '../../../common/SelectInput'
import Button from '../../../common/Button'
import { getRequest, postRequest, putRequest } from '../../../../services/base'
import { useParams } from 'react-router-dom'
import { NavContext } from '../../../../context/global_context'

const WireForm = (props) => {
  const { vehicle } = useParams()
  const [state, dispatch] = useContext(WireContext)
  const [navState, navDispatch] = useContext(NavContext)
  const [options, setOptions] = useState({
    harness: [],
    connector_from: [],
    connector_to: [],
    circuit: [],
    device_connection: [],
    color: [],
    device: [],
  })

  const getHarnessOptions = async (search = '') => {
    let res = await getRequest(
      `/api/harnesses/?vehicle=${vehicle}&search=${search}`
    )
    setOptions({ ...options, harness: res.results })
  }

  const getConnectorOptions = async (search = '', field = '') => {
    let res = await getRequest(
      `/api/connector/?vehicle=${vehicle}&search=${search}`
    )
    setOptions({ ...options, [field]: res.results })
  }

  const getColorOptions = async (search = '') => {
    let res = await getRequest(
      `/api/color/?vehicle=${vehicle}&search=${search}`
    )
    setOptions({ ...options, color: res.results })
  }

  const getCircuitOptions = async (search = '') => {
    let res = await getRequest(
      `/api/circuit/options/?vehicle=${vehicle}&search=${search}&limit=50`
    )
    setOptions({ ...options, circuit: res.results })
  }

  const getDeviceOptions = async (search = '') => {
    let res = await getRequest(
      `/api/devices/?vehicle=${vehicle}&search=${search}`
    )
    setOptions({ ...options, device: res.results })
  }

  const getDeviceConnectionsOptions = async (search = '') => {
    let res = await getRequest(
      `/api/device_connection/?vehicle=${vehicle}&search=${search}`
    )
    setOptions({ ...options, device_connection: res.results })
  }

  const saveWireForm = async (e) => {
    if (
      window.confirm(
        `Are you sure, you want to save wire with this details`
      ) === true
    ) {
      navDispatch({
        type: 'loader',
        data: {
          caption: 'Save Wire details is in progress...',
          showLoader: true,
        },
        notification: {},
      })

      const form = e.target
      const formData = new FormData(form)
      if (state?.selectedObject?.id) {
        let res = await putRequest(
          `/api/wire/${state?.selectedObject?.id}/?vehicle=${vehicle}`,
          formData
        )
        successErrorHandle(res)
      } else {
        let res = await postRequest(`/api/wire/?vehicle=${vehicle}`, formData)
        successErrorHandle(res)
      }
    }
  }

  const successErrorHandle = (res) => {
    if (res?.invalid_levels?.length > 0) {
      dispatch({
        type: SET_SELECTED_WIRE_DATA,
        data: { ...state?.selectedObject, id: res.data.id },
      })
      navDispatch({
        type: 'notification',
        data: {
          notification_type: 'error',
          msg: `${res?.invalid_levels} levels not exists, Please correct levels.`,
        },
      })
    } else if (res?.status) {
      navDispatch({
        type: 'notification',
        data: {
          notification_type: 'success',
          msg: `Wire Saved Successfully`,
        },
      })
      props.onClose()
    } else {
      let msg = ''
      Object.keys(res).map((obj) => {
        if (msg) {
          msg += `, ${res[obj]}`
        } else {
          msg = `${res[obj]}`
        }
      })
      navDispatch({
        type: 'notification',
        data: {
          notification_type: 'error',
          msg: msg,
        },
      })
    }
  }

  return (
    <div className="" style={{ height: '80vh' }}>
      <form
        onSubmit={(e) => {
          e.preventDefault()
          saveWireForm(e)
        }}
      >
        <input
          type="hidden"
          value={state?.selectedObject?.id ? false : true}
          name="is_create"
        />
        <input type="hidden" value={vehicle} name="vehicle" />
        {state?.selectedObject?.id && (
          <input type="hidden" name="id" value={state?.selectedObject?.id} />
        )}
        <input
          type="hidden"
          name="import_file"
          value={
            state?.selectedObject?.import_file
              ? state?.selectedObject?.import_file
              : null
          }
        />
        <div className="flex justify-between">
          <SelectInput
            name="harness"
            label="Harness"
            options={options.harness}
            value={state.selectedObject?.harness}
            onInputChange={(value) => {
              if (value) {
                getHarnessOptions(value)
              }
            }}
            onChange={(value) => {
              dispatch({
                type: SET_SELECTED_WIRE_DATA,
                data: {
                  ...state?.selectedObject,
                  harness: value,
                },
              })
            }}
            onMenuOpen={() => {
              if (options.harness?.length < 1) {
                getHarnessOptions('')
              }
            }}
            formatOptionLabel={(option) => (
              <>
                <div className="">{option.harness_id}</div>
              </>
            )}
            optionValue="id"
            isRequired={false}
          />
          <SelectInput
            name="connector_from"
            label="Connector From"
            options={options.connector_from}
            value={state.selectedObject?.connector_from}
            onInputChange={(value) => {
              if (value) {
                getConnectorOptions(value, 'connector_from')
              }
            }}
            onChange={(value) => {
              dispatch({
                type: SET_SELECTED_WIRE_DATA,
                data: {
                  ...state?.selectedObject,
                  connector_from: value,
                },
              })
            }}
            onMenuOpen={() => {
              if (options.connector_from?.length < 1) {
                getConnectorOptions('', 'connector_from')
              }
            }}
            optionLabel={'name'}
            optionValue={'id'}
          />
          <SelectInput
            name="connector_to"
            label="Connector To"
            options={options.connector_to}
            value={state.selectedObject?.connector_to}
            onInputChange={(value) => {
              if (value) {
                getConnectorOptions(value, 'connector_to')
              }
            }}
            onChange={(value) => {
              dispatch({
                type: SET_SELECTED_WIRE_DATA,
                data: {
                  ...state?.selectedObject,
                  connector_to: value,
                },
              })
            }}
            onMenuOpen={() => {
              if (options.connector_to?.length < 1) {
                getConnectorOptions('', 'connector_to')
              }
            }}
            optionLabel={'name'}
            optionValue={'id'}
          />
          <InputText
            name="option_code_expression"
            type="text"
            label={`Option Code Expression`}
            value={state.selectedObject?.option_code_expression}
            onChange={(value) => {
              dispatch({
                type: SET_SELECTED_WIRE_DATA,
                data: {
                  ...state?.selectedObject,
                  option_code_expression: value,
                },
              })
            }}
            isRequired={false}
          />
        </div>
        <div className="flex justify-between">
          <InputText
            name="size"
            type="text"
            label={`Size`}
            value={state.selectedObject?.size}
            onChange={(value) => {
              dispatch({
                type: SET_SELECTED_WIRE_DATA,
                data: {
                  ...state?.selectedObject,
                  size: value,
                },
              })
            }}
          />
          <InputText
            name="pin_from"
            type="text"
            label={`Pin From`}
            value={state.selectedObject?.pin_from}
            onChange={(value) => {
              dispatch({
                type: SET_SELECTED_WIRE_DATA,
                data: {
                  ...state?.selectedObject,
                  pin_from: value,
                },
              })
            }}
          />
          <InputText
            name="pin_to"
            type="text"
            label={`Pin To`}
            value={state.selectedObject?.pin_to}
            onChange={(value) => {
              dispatch({
                type: SET_SELECTED_WIRE_DATA,
                data: {
                  ...state?.selectedObject,
                  pin_to: value,
                },
              })
            }}
          />
          <SelectInput
            name="color"
            label="Color"
            options={options.color}
            value={state.selectedObject?.color}
            onInputChange={(value) => {
              if (value) {
                getColorOptions(value)
              }
            }}
            onChange={(value) => {
              dispatch({
                type: SET_SELECTED_WIRE_DATA,
                data: {
                  ...state?.selectedObject,
                  color: value,
                },
              })
            }}
            onMenuOpen={() => {
              if (options.color?.length < 1) {
                getColorOptions('')
              }
            }}
            optionLabel={'name'}
            optionValue={'id'}
            isRequired={false}
          />
        </div>
        <div className="flex justify-between">
          <div className="flex items-center p-2 w-full">
            <CheckBox
              name={'internal'}
              value={state?.selectedObject?.internal}
              checked={state?.selectedObject?.internal}
              onChange={(e) => {
                dispatch({
                  type: SET_SELECTED_WIRE_DATA,
                  data: {
                    ...state?.selectedObject,
                    internal: e.target.checked,
                  },
                })
              }}
            />
            <span className="pl-2 text-white">Internal</span>
          </div>
          <div className="flex items-center p-2 w-full">
            <CheckBox
              name={'can_star'}
              value={state?.selectedObject?.can_star}
              checked={state?.selectedObject?.can_star}
              onChange={(e) => {
                dispatch({
                  type: SET_SELECTED_WIRE_DATA,
                  data: {
                    ...state?.selectedObject,
                    can_star: e.target.checked,
                  },
                })
              }}
            />
            <span className="pl-2 text-white">Can Star</span>
          </div>
          <SelectInput
            name="circuit"
            label="Circuit"
            options={options.circuit}
            value={state.selectedObject?.circuit}
            onInputChange={(value) => {
              if (value) {
                getCircuitOptions(value)
              }
            }}
            onChange={(value) => {
              dispatch({
                type: SET_SELECTED_WIRE_DATA,
                data: {
                  ...state?.selectedObject,
                  circuit: value,
                },
              })
            }}
            onMenuOpen={() => {
              if (options.circuit?.length < 1) {
                getCircuitOptions('')
              }
            }}
            optionLabel={'name'}
            optionValue={'id'}
          />
          <SelectInput
            name="device"
            label="Device"
            options={options.device}
            value={state.selectedObject?.device}
            onInputChange={(value) => {
              if (value) {
                getDeviceOptions(value)
              }
            }}
            onChange={(value) => {
              dispatch({
                type: SET_SELECTED_WIRE_DATA,
                data: {
                  ...state?.selectedObject,
                  device: value,
                },
              })
            }}
            onMenuOpen={() => {
              if (options.device?.length < 1) {
                getDeviceOptions('')
              }
            }}
            optionLabel={'name'}
            optionValue={'id'}
            isRequired={false}
          />
        </div>
        <div className="flex justify-between">
          <SelectInput
            name="device_connection"
            label="Device Connection"
            options={options.device_connection}
            value={state.selectedObject?.device_connection}
            onInputChange={(value) => {
              if (value) {
                getDeviceConnectionsOptions(value)
              }
            }}
            onChange={(value) => {
              dispatch({
                type: SET_SELECTED_WIRE_DATA,
                data: {
                  ...state?.selectedObject,
                  device: value,
                },
              })
            }}
            onMenuOpen={() => {
              if (options.device_connection?.length < 1) {
                getDeviceConnectionsOptions('')
              }
            }}
            optionValue={'id'}
            isRequired={false}
            formatOptionLabel={(option) => (
              <>
                <div className="">{option.signal}</div>
                <div className="">
                  {option.pin_from} - {option.pin_to}
                </div>
              </>
            )}
          />
          <TextArea
            name="note"
            type="text"
            label={`Note`}
            value={state.selectedObject?.note}
            onChange={(value) => {
              dispatch({
                type: SET_SELECTED_WIRE_DATA,
                data: {
                  ...state?.selectedObject,
                  note: value,
                },
              })
            }}
            wrapperClass="text-white p-2"
            isRequired={false}
          />
          <div className="w-full">
            <TextArea
              name="level_string"
              type="text"
              label={`Level String`}
              value={state.selectedObject?.level_string}
              onChange={(value) => {
                dispatch({
                  type: SET_SELECTED_WIRE_DATA,
                  data: {
                    ...state?.selectedObject,
                    level_string: value,
                  },
                })
              }}
              wrapperClass="text-white p-2"
              hint={`**Please put comma seperated values`}
              isRequired={false}
            />
          </div>
        </div>
        <div className="flex justify-end">
          <div className="w-1/4">
            <Button
              type="submit"
              className={`cursor-pointer btn my-4 w-full justify-end`}
              onClick={(e) => {}}
              value={'text'}
              text={'Save Wirelist File'}
            />
          </div>
        </div>
      </form>
    </div>
  )
}

export default WireForm
